import { getUserRoles, isAuthenticated } from '@/utils/auth';
import { createRouter, createWebHistory } from 'vue-router';
const HomePage = ()=> import('@/pages/LandingPage.vue');
const NotFound = () => import('@/pages/NotFound.vue');
const AppLayout = ()=> import('@/layouts/AppLayout.vue');
const AuthLayout = ()=>import('@/layouts/AuthLayout.vue')
const LoginPage = ()=>import('@/pages/users/LoginPage.vue')
const routes = [
    {
        path: '/',
        component: AppLayout,
        meta:{requiresAuth: true,title: "Dashboard"},
        children:[
            {
                path: '',
                name: 'home',
                component: HomePage,
              //  meta: {trackRecent: true, icon: 'bi bi-speedometer2'}
            },
        ]
    },
     {
        path: '/login',
        component: AuthLayout,
        meta: { requiresGuest: true,title: 'Login' }, // Only accessible when not authenticated
        children: [
            {
                path: '',
                name: 'login',
                component: LoginPage
            }
        ]
    },
    { path: '/:catchAll(.*)', component: NotFound, meta: { showHeader: false } }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        return savedPosition || { top: 0 };
    }
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Emergency System'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'home' })
    }

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const userRoles = getUserRoles(); // Example function to get user roles
        const allowedRoles = to.meta.roles;

        // Check if any of the user's roles match the allowed roles
        const hasAccess = userRoles.some(role => allowedRoles.includes(role));

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }
    }

    next()
})



export default router;
